import ReactPlayer from "react-player";
import { useModal } from "../../hooks/modalStore";
import { endpoints, VIDEO_CHUNK_SIZE } from "../../utils/config";
import Styles from "./VideoList.module.css";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import moment from "moment/moment";

export function VideoWrapper({
  video_id,
  video_src,
  res_720,
  name,
  preview_src,
  length,
  watched_bytes,
}) {
  const modalStore = useModal();
  const { handleOpen, handleClose } = modalStore;

  const handleOpenVideo = () => {
    handleOpen(
      <VideoPlayer
        res_720={res_720}
        video_src={video_src}
        id={video_id}
        onClose={handleClose}
        name={name}
      />,
    );
  };
  const chunkCount = Math.floor(length / VIDEO_CHUNK_SIZE);
  const progressColumns = [];
  for (let index = 0; index < chunkCount; index++) {
    progressColumns.push("1fr");
  }

  return (
    <div className={Styles.video_item}>
      <div
        onClick={handleOpenVideo}
        className={Styles.video_cover}
        style={{
          backgroundImage: `url(${endpoints.image}/preview/${preview_src})`,
        }}>
        <div className={Styles.video_play_cover}>
          <PlayArrowRoundedIcon className={Styles.video_play_button} />
        </div>
        {/* <div className={Styles.video_label}>
          <span style={{ margin: 0, fontSize: "12px" }}>
            {moment.utc(length).format("HH:mm:ss")}
          </span>
        </div> */}
        <div
          className={Styles.video_progress}
          style={{ gridTemplateColumns: `${progressColumns.join(" ")}` }}>
          {watched_bytes.map((byte, index) => (
            <div
              style={{
                backgroundColor: "var(--baze-correct)",
                borderBottomLeftRadius: index == 0 && "100%",
              }}></div>
          ))}
        </div>
      </div>
      <p className={Styles.video_name}>{name}</p>
    </div>
  );
}
